import {Participant} from "@app/shared/models/Participant";

export interface Categorized{
  category?: Category
}

export class Category{
  id: number
  name: string
  selected?: boolean
}

export class Reward implements Categorized{
  id:number
  name: string
  description: string
  image: string
  points: number
  category?: Category
}

export class Purchase{
  participant: Participant
  reward: Reward
  created: string
  updated: string
  // category?:Category

  get category(){ return this.reward?.category }
  set category(category:Category){
    if(this.reward) this.reward.category = category
  }
}

export class PointBalance{
  point_earned: number
  point_used: number
  point_balance: number
}
